import styles from './informacaoBasica.module.scss';
import classNames from 'classnames';
function InformacaoBasica({ titulo, conteudo, classe }: { titulo: string; conteudo: string; classe?: string }) {
  return (
    <>
      {!!conteudo && (
        <div
          className={classNames(styles.item, styles[`${classe}`])}
          tabIndex={0}
          aria-label={`${titulo}: ${conteudo}`}
        >
          <strong> {titulo} </strong>
          <p> {conteudo} </p>
        </div>
      )}
    </>
  );
}

export default InformacaoBasica;
